// ============================================================================
// CoberturaMiniList — captura una lista simple de coberturas (nombre, límite/
// sublímite, suma asegurada, deducible). Se usa para las coberturas POR UNIDAD
// (dentro de cada vehículo) al emitir una flota y al incluir un vehículo por endoso.
// value: array de coberturas; onChange(nextArray).
// ============================================================================
import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

export const EMPTY_COB = { nombre: '', tipo_limite: 'limite', suma_asegurada: '', deducible: '' };

export default function CoberturaMiniList({ value, onChange, compact }) {
  const list = value || [];
  const update = (idx, k, v) => onChange(list.map((x, i) => i === idx ? { ...x, [k]: v } : x));
  const add = () => onChange([...list, { ...EMPTY_COB }]);
  const remove = (idx) => onChange(list.filter((_, i) => i !== idx));

  return (
    <div>
      {list.map((c, idx) => (
        <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 1.1fr 1.2fr 1.6fr auto', gap: 8, alignItems: 'end', marginBottom: 8 }}>
          <div className="form-group" style={{ margin: 0 }}>
            {idx === 0 && <label className="form-label">Cobertura</label>}
            <input className="form-input" value={c.nombre} onChange={e => update(idx, 'nombre', e.target.value)} placeholder="Ej: Daños a terceros" />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            {idx === 0 && <label className="form-label">Tipo</label>}
            <select className="form-select" value={c.tipo_limite || 'limite'} onChange={e => update(idx, 'tipo_limite', e.target.value)}>
              <option value="limite">Límite</option>
              <option value="sub_limite">Sub-límite</option>
            </select>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            {idx === 0 && <label className="form-label">Suma asegurada</label>}
            <input className="form-input" type="number" step="0.01" value={c.suma_asegurada} onChange={e => update(idx, 'suma_asegurada', e.target.value)} placeholder="0.00" />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            {idx === 0 && <label className="form-label">Deducible</label>}
            <input className="form-input" value={c.deducible} onChange={e => update(idx, 'deducible', e.target.value)} placeholder="Ej: 1% / mín. 250" />
          </div>
          <button type="button" className="btn btn-icon btn-danger btn-sm" onClick={() => remove(idx)} title="Quitar cobertura" style={{ marginBottom: 1 }}>
            <Trash2 size={13} />
          </button>
        </div>
      ))}
      <button type="button" className="btn btn-secondary btn-sm" onClick={add}>
        <Plus size={13} /> Agregar cobertura{compact ? '' : ' a esta unidad'}
      </button>
    </div>
  );
}
